export default __webpack_public_path__ + "static/media/aboutIsa-01.9b8f43a5.jpg";